import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { findVrmDeviceClassify } from '@/service/vibrationEquipment';
import { useStore } from '@/store';
export default function useGoupListNew() {
  var store = useStore();
  var deviceGroup = ref([]);
  var loading = ref(true);
  var curSiderbarIndex = computed(function () {
    return store.state.vibrationEquipment.curSiderbarIndex;
  });
  // 获取设备振动汇总数据
  var getDeviceGroupAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            _context.next = 4;
            return findVrmDeviceClassify();
          case 4:
            data = _context.sent;
            deviceGroup.value = data.list;
            if (!data.list.filter(function (item) {
              return item.factoryId;
            }).map(function (item) {
              return item.factoryId;
            }).includes(store.state.vibrationEquipment.curSiderbarId)) {
              // 有可能是切换厂区了，也有可能是没切换厂区，只是菜单列表被操作用在后台修改了（增删改）,设备列表当前选中菜单索引置零
              store.commit('vibrationEquipment/updateSiderbarIndex', 0);
              store.commit('vibrationEquipment/updateSiderbarId', 0);
              store.commit('vibrationEquipment/updateSiderbar', data.list);
            } else {
              // 没有切换厂区
              store.commit('vibrationEquipment/updateSiderbar', data.list);
              store.commit('vibrationEquipment/updateSiderbarId', data.list[curSiderbarIndex.value].factoryId);
            }
            loading.value = false;
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            loading.value = false;
            console.log(_context.t0);
          case 14:
            _context.prev = 14;
            console.log('finally');
            return _context.finish(14);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10, 14, 17]]);
    }));
    return function getDeviceGroupAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [deviceGroup, loading, getDeviceGroupAsync];
}